<template>
  <div class="job-shift">
    <p class="job-shift__days">{{ daysLabel }}</p>
    <p class="job-shift__time-range">
      <span class="job-shift__time job-shift__time--start">{{ startTime }}</span>
      <span class="job-shift__arrow">-</span>
      <span class="job-shift__time job-shift__time--end">{{ endTime }}</span>
      <!-- Always render fixed-width +1 block for aligning to right -->
      <span class="job-shift__time-overnight">
        <template v-if="isOvernight">(+1)</template>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    daysLabel() {
      if (this.dayGroups.length) {
        return this.dayGroups.map(this.formatDayGroup).join(', ')
      }
      return this.$t('dayOfWeek.negotiable')
    },
  },
  methods: {
    formatDayGroup(group) {
      if (Array.isArray(group) && group.length) {
        const start = this.$t(`dayOfWeek['${group[0]}']`)
        const end = this.$t(`dayOfWeek['${group[group.length - 1]}']`)

        switch (group.length) {
          case 1:
            return start
          case 2:
            return `${start}, ${end}`
          default:
            return this.$t('dayOfWeek.multiple', { end, start })
        }
      }
      return ''
    },
  },
  props: {
    dayGroups: {
      default: () => [],
      type: Array,
    },
    endTime: {
      required: true,
      type: String,
    },
    isOvernight: {
      default: false,
      type: Boolean,
    },
    startTime: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-shift {
  @apply flex items-center;
}
.job-shift__days {
  @apply flex-grow;
}
.job-shift__time-range {
  @apply flex-shrink-0 flex w-shift-item ml-2;

  & .job-shift__time {
    width: 2.8em;
  }
  & .job-shift__time--start {
    @apply text-left;
  }
  & .job-shift__time--end {
    @apply text-right;
  }
  & .job-shift__arrow {
    @apply text-center;
    width: 0.5em;
  }
  & .job-shift__time-overnight {
    width: 2.3em;
    margin-left: 0.25em;
  }
}

@screen desktop {
  .job-shift__time-range {
    @apply w-shift-item-desktop;
  }
}
</style>
